/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import { get } from 'lodash'
import onClickOutside from 'react-onclickoutside'

/**
 *     Import
 *     - Components
 */
// import { DropdownArrowIcon } from '../../../../../images/icons/DropdownArrow/DropdownArrow'
// import OptionsItem from '../../Step05/components/OptionsItem'
import OptionsCheckbox from '../../Step05/components/OptionsCheckbox'
import { Alert } from '../../../../common/Alert/Alert'
import { symbol } from '../../../../common/CurrencyFormat'
import ToolTip from '../../../../common/ToolTip/ToolTip'
import { Dropdown } from '../../../../common/Dropdown/Dropdown'
import { BinIcon } from '../../../../../images/icons/Bin/Bin'

var EnhancedComponent = onClickOutside(Dropdown)

const REGEXP = '^(?!(?:^[-+]?[0.]+(?:[Ee]|$)))(?!(?:^-))(?:(?:[+-]?)(?=[0123456789.])' +
    '(?:(?:(?:[0123456789]+)(?:(?:[.])(?:[0123456789]*))?|(?:(?:[.])(?:[0123456789]+))))' +
    '(?:(?:[Ee])(?:(?:[+-]?)(?:[0123456789]+))|))$'

/**
 *     Step main container
 */
export default class VariationOptions extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
        this.state = {
            values: this.props.values,
            dirty: false,
            errorList: [],
            showErrorOfCovar: false,
        }
    }

    handleCheckbox = () => {
        return true
    }

    handleItemChange = (field: string, value: any, inputSec = false) => {
        if (this.props.dirty) {
            this.props.dirty(true)
        }

        if (inputSec && value !== '') {
            value = value.replace(/^-*/, '').replace(/^0+/, '')
        }

        this.setState({
            values: { ...this.state.values, [field]: value },
            dirty: true,
        })

        if (value && ((field === 'localExhibitions' && get(this.state, 'values.internationalExhibitions', 0) > 0) ||
            (field === 'internationalExhibitions' && get(this.state, 'values.localExhibitions', 0) > 0)) || (
                field === 'numberOfExhibitions' && ((get(this.state, 'values.localExhibitions', 0) > 0) &&
                    (get(this.state, 'values.internationalExhibitions', 0) > 0))
            )) {
            this.noOfExhibition(field === 'numberOfExhibitions' ? value < 2 ? 0 : value : 2)
        } else {
            if (field === 'localExhibitions' ||
                field === 'internationalExhibitions' || field === 'numberOfExhibitions') {
                this.noOfExhibition(field === 'numberOfExhibitions' ? value < 1 ? 0 : value : 1)
            }
        }
    }

    noOfExhibition = (val: any) => {
        setTimeout(() => { this.setState({ values: { ...this.state.values, ['numberOfExhibitions']: val } }) }, 0)
    }

    handleSubmit = (event: any) => {
        event.preventDefault()
        let errorList: any = []
        let {
            temporaryRemovalCoverValue,
            temporaryRemovalCover,
            incomingExhibitionLimit,
            outgoingExhibitionLimit,
            exhibitionCover,
            internationalExhibitions,
            numberOfExhibitions,
            limitPerExhibition,
            localExhibitions,
            tradeFairsLoc,
        } = this.state.values

        if (temporaryRemovalCover) {
            if (parseFloat(temporaryRemovalCoverValue) <
                (parseFloat(incomingExhibitionLimit) + parseFloat(outgoingExhibitionLimit))) {
                errorList.push(
                    'Temporary Removal Cover value is less than the sum of incoming and outgoing exhibition limits.')
            }

            if (!temporaryRemovalCoverValue || parseInt(temporaryRemovalCoverValue, 10) === 0) {
                errorList.push('Temporary Removal Cover value is required.')
            }
        }

        if (exhibitionCover) {
            if (!numberOfExhibitions || parseInt(numberOfExhibitions, 10) === 0) {
                errorList.push('Number of exhibitions is required.')
            }

            if (!limitPerExhibition || parseInt(limitPerExhibition, 10) === 0) {
                errorList.push('Limit per exhibition is required.')
            }

            if (Number(localExhibitions) > 0 && Number(localExhibitions) < limitPerExhibition) {
                errorList.push(`Domestic fairs or exhibition must be greater than or equal to the Maximum sum insured.`)
            }

            if (Number(internationalExhibitions) > 0 && Number(internationalExhibitions) < limitPerExhibition) {
                errorList.push(`International fairs or exhibition must be greater 
                    than or equal to the Maximum sum insured.`)
            }

            if ((Number(localExhibitions) + Number(internationalExhibitions)) < limitPerExhibition) {
                errorList.push(
                    `The total number of exhibitions (both local and international) must 
                    not exceed the maximum sum insured.`
                )
            }

            if (tradeFairsLoc.length === 0) {
                errorList.push('Trade Fairs Locations are required.')
            } else {
                const sumExhibitions = (Number(localExhibitions) + Number(internationalExhibitions))
                const sumValues = tradeFairsLoc.reduce((acc, curr) => acc + parseFloat(curr.value), 0)
                if (sumValues !== sumExhibitions) {
                    errorList.push(`The trade fairs location sum should be equal to 
                        the total number of exhibitions (both local and international).`)
                }
            }
        }

        if (errorList.length !== 0) {
            this.setState({ errorList: errorList, validateErr: true })
        } else {
            this.setState({ validateErr: false, showErrorOfCovar: false })
            this.props.handleAdjustChangeOptions(this.state.values)
            this.setState({ dirty: false, errorList: [] })
            if (this.props.dirty) {
                this.props.dirty(false)
            }
        }
    }

    addTradeFairsLoc = () => {
        this.setState(prevState => {
            const newTradeFairsLoc = [
                ...prevState.values.tradeFairsLoc,
                { id: '', title: '', value: '' },
            ]
            return {
                values: {
                    ...prevState.values,
                    tradeFairsLoc: newTradeFairsLoc,
                },
            }
        })
    }

    updateTradeFairsLoc = (index: number, field: string, value: any) => {
        const {
            tradeFairsLocations,
            dirty,
        } = this.props

        this.setState(
            prevState => {
                const updatedTradeFairsLoc = [...prevState.values.tradeFairsLoc]
                updatedTradeFairsLoc[index][field] = value

                if (field === 'id' && Array.isArray(tradeFairsLocations.data)) {
                    const selectedLocation = tradeFairsLocations.data.find(item => item.id === value)
                    if (selectedLocation) {
                        updatedTradeFairsLoc[index].title = selectedLocation.title
                    }
                }

                return {
                    values: {
                        ...prevState.values,
                        tradeFairsLoc: updatedTradeFairsLoc,
                    },
                }
            },
            () => {
                if (dirty) {
                    dirty(true)
                }
                this.setState({ dirty: true })
            }
        )
    }

    removeTradeFairsLoc = (idx) => {
        const { dirty } = this.props
        this.setState(
            prevState => {
                const updatedTradeFairsLoc = prevState.values.tradeFairsLoc.filter((_, i) => i !== idx)

                return {
                    values: {
                        ...prevState.values,
                        tradeFairsLoc: updatedTradeFairsLoc,
                    },
                }
            },
            () => {
                if (dirty) {
                    dirty(true)
                }
                this.setState({ dirty: true })
            }
        )
    }

    render() {
        const {
            temporaryRemovalCover,
            exhibitionCover,
            temporaryRemovalCoverValue,
            localExhibitions,
            internationalExhibitions,
            numberOfExhibitions,
            limitPerExhibition,
            tradeFairsLoc,
        } = this.state.values
        const { validateErr, errorList } = this.state
        let exceptionValidation = (Number(localExhibitions) + Number(internationalExhibitions)) === 0
        const { tradeFairsLocList = [] } = this.props
        return (
            <div>
                <form
                    onSubmit={this.handleSubmit}
                    className={`${this.props.optionsOpen ? 'open' : null}
                      ${this.state.dirty ? 'plus57' : null}`}
                >
                    <div
                        className={`variation__options__content options ${!this.props.optionsOpen ? 'closed' : null}`}
                    >
                        {errorList.length > 0 && errorList.map((a, i) => {
                            return (
                                <Alert
                                    type="error"
                                    key={i}
                                    className={`errorMessage ${(this.state.errorList.length) ? 'visible' : ''}`}
                                >
                                    <p>{a}</p>
                                </Alert>
                            )
                        })}

                        <OptionsCheckbox
                            id="terrorism"
                            title="Add terrorism cover"
                            handleItemChange={this.handleItemChange}
                            checked={this.props.values.terrorism || false}
                            value={this.props.values.terrorism}
                        >
                            Insurers subscribe to Pool Re and, accordingly, if selected cover will extend to all
                            material damage and consequential loss sections.
                        </OptionsCheckbox>

                        <OptionsCheckbox
                            id="temporaryRemovalCover"
                            title="Limit for transits and or unnamed locations"
                            handleItemChange={this.handleItemChange}
                            checked={this.props.values.temporaryRemovalCover || false}
                            value={this.props.values.temporaryRemovalCover}
                            tooltipView={false}
                        />

                        <div className={`options__item item_group ${!(temporaryRemovalCover) ? `hidden` : ``}`}>
                            <div className="input_group">
                                <div className="input_group_sec left">
                                    <div className="input_sec">
                                        <label>Limit per shipment or unnamed location worldwide *
                                            <ToolTip
                                                position="left"
                                                verticalPosition="top"
                                                customCls="setMaxWidth"
                                                parntCls="setMargin"
                                            >
                                                Any one loss whilst in transit anywhere World-wide &/or whilst entrusted
                                                to third parties &/or in storage &/or at restorers &/or at framers &/or
                                                at auction houses &/or at any other unnamed location anywhere world-wide
                                                but Limited to GBP 20,000 in respect of any sending by Post, Registered
                                                Post, Recorded Delivery, Insured Parcel Post, courier or tracked service
                                                etc
                                            </ToolTip>
                                        </label>

                                        <div
                                            className={`input 
                                         ${(temporaryRemovalCover &&
                                                    (!temporaryRemovalCoverValue ||
                                                        parseInt(temporaryRemovalCoverValue, 10) === 0) &&
                                                    validateErr === true) ?
                                                    'error_border' : ''}`}
                                        >
                                            <div className="pound">{symbol()}</div>
                                            <input
                                                name="temporaryRemovalCoverValue"
                                                placeholder="0"
                                                type="number"
                                                min="0"
                                                step="any"
                                                onChange={(event) => {
                                                    let v = event.target.value
                                                    this.handleItemChange('temporaryRemovalCoverValue', v, true)
                                                }}
                                                value={temporaryRemovalCoverValue}
                                            />
                                        </div>
                                    </div>
                                    <div className="input_sec">
                                        {/* empty value */}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <OptionsCheckbox
                            id="exhibitionCover"
                            title="Exhibition / Fair cover"
                            handleItemChange={this.handleItemChange}
                            checked={this.props.values.exhibitionCover || false}
                            value={this.props.values.exhibitionCover}
                            tooltipView={false}
                        />

                        <div className={`options__item item_group ${!(exhibitionCover) ? `hidden` : ``}`}>
                            <div className="input_group">
                                <div className="input_group_sec left">
                                    <div className="input_sec">
                                        <label className="variation_label">Total aggregate value of stock during
                                            the policy period at domestic Fairs or exhibitions *</label>
                                        <div
                                            className={`input 
                                         ${(exhibitionCover && exceptionValidation === true && validateErr === true) ?
                                                    'error_border' : ''}`}
                                        >
                                            <div className="pound">{symbol()}</div>
                                            <input
                                                name="localExhibitions"
                                                placeholder="0"
                                                type="number"
                                                min="0"
                                                step="any"
                                                onChange={(event) => {
                                                    let v = event.target.value
                                                    this.handleItemChange('localExhibitions', v, true)
                                                }}
                                                value={localExhibitions}
                                            />
                                        </div>
                                    </div>
                                    <div className="input_sec">
                                        <label className="variation_label">Total aggregate value of stock during the
                                            policy period at international Fairs or exhibitions *</label>
                                        <div
                                            className={`input 
                                         ${(exhibitionCover && exceptionValidation === true && validateErr === true) ?
                                                    'error_border' : ''}`}
                                        >
                                            <div className="pound">{symbol()}</div>
                                            <input
                                                name="internationalExhibitions"
                                                placeholder="0"
                                                type="number"
                                                min="0"
                                                step="any"
                                                onChange={(event) => {
                                                    let v = event.target.value
                                                    this.handleItemChange('internationalExhibitions', v, true)
                                                }}
                                                value={internationalExhibitions}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="input_group_sec right">
                                    <div className="input_sec">
                                        <label className="variation_label">Total number of fairs or exhibitions planned
                                            during the policy period *</label>
                                        <div
                                            className={`input input__no-symbol 
                                         ${(exhibitionCover &&
                                                    (!numberOfExhibitions || parseInt(numberOfExhibitions, 10) === 0) &&
                                                    validateErr === true) ?
                                                    'error_border' : ''}`}
                                        >
                                            <input
                                                name="numberOfExhibitions"
                                                placeholder="0"
                                                type="number"
                                                max={Number(localExhibitions) === 0 ||
                                                    Number(internationalExhibitions) === 0 ? '' : ''}
                                                min={exhibitionCover ? Number(localExhibitions) !== 0 &&
                                                    Number(internationalExhibitions) !== 0 ? '2' : '1' : '0'}
                                                step="any"
                                                onChange={(event) => {
                                                    let v = event.target.value
                                                    this.handleItemChange('numberOfExhibitions', v, true)
                                                }}
                                                value={numberOfExhibitions}
                                            />
                                        </div>
                                    </div>
                                    <div className="input_sec">
                                        <label className="variation_label">Maximum sum insured per fair of exhibition *
                                        </label>
                                        <div
                                            className={`input 
                                         ${(exhibitionCover &&
                                                    (!limitPerExhibition || parseInt(limitPerExhibition, 10) === 0) &&
                                                    validateErr === true) ?
                                                    'error_border' : ''}`}
                                        >
                                            <div className="pound">{symbol()}</div>
                                            <input
                                                name="limitPerExhibition"
                                                placeholder="0"
                                                type="number"
                                                min="0"
                                                step="any"
                                                onChange={(event) => {
                                                    let v = event.target.value
                                                    this.handleItemChange('limitPerExhibition', v, true)
                                                }}
                                                value={limitPerExhibition}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={`art_fairs_list_opt ${!(exhibitionCover) ? `hidden` : ``}`}>
                                <span className="sec_title">Art Fairs Locations:</span>
                                {tradeFairsLocList && tradeFairsLocList.length > 0 && tradeFairsLoc &&
                                    tradeFairsLoc.length > 0 && tradeFairsLoc.map((oneItem, idx) => {
                                        return (
                                            <div className="table__content" key={idx}>
                                                <div className="table__50-item">
                                                    <EnhancedComponent
                                                        key={`enhanced_${oneItem.id}`}
                                                        itemList={tradeFairsLocList}
                                                        name="id"
                                                        setFieldValue={(state, value) => {
                                                            if (!oneItem.id) {
                                                                this.updateTradeFairsLoc(idx, state, value)
                                                            }
                                                        }}
                                                        check={true}
                                                        label="Choose trade fairs location"
                                                        labelShow={false}
                                                        selected={[
                                                            oneItem.id,
                                                            oneItem.id === 0 ? 'other' : oneItem.title,
                                                            oneItem.value,
                                                        ]}
                                                    />
                                                    {(oneItem.id === 0 || oneItem.title === 'other') && (
                                                        <div className="input input__no-symbol other_loc" >
                                                            <input
                                                                className="dealer_input"
                                                                name="trade_val"
                                                                onChange={(e) =>
                                                                    this.updateTradeFairsLoc(
                                                                        idx, 'title', e.target.value)
                                                                }
                                                                value={oneItem.title}
                                                                placeholder="Title"
                                                                step="any"
                                                            />
                                                        </div>
                                                    )}
                                                </div>

                                                <div className="table__40-item">
                                                    <div className="input">
                                                        <div className="pound">
                                                            {symbol()}
                                                        </div>
                                                        <input
                                                            type="number"
                                                            className="dealer_input"
                                                            name="value"
                                                            onChange={(e) =>
                                                                this.updateTradeFairsLoc(idx, 'value', e.target.value)
                                                            }
                                                            value={oneItem.value}
                                                            placeholder="0"
                                                            step="any"
                                                            min="0"
                                                            pattern={REGEXP}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="table__10-item">
                                                    <button
                                                        type="button"
                                                        onClick={() => { this.removeTradeFairsLoc(idx) }}
                                                        className="trade_remove_btn"
                                                    >
                                                        <BinIcon color={'#F07662'} />
                                                    </button>
                                                </div>

                                            </div>
                                        )
                                    })}
                                <div className={`fairs_btn`} onClick={this.addTradeFairsLoc}>Add Fairs</div>
                            </div>
                        </div>

                    </div>
                    {(this.state.showErrorOfCovar) ? (

                        <Alert type="error">
                            Error: Incoming/Outgoing Limit must not exceed Cover Value.
                        </Alert>

                    ) : null}
                    <button className={`submit ${this.state.dirty ? 'visible' : null}`} type="submit">Update</button>
                </form>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step05d/components/VariationOptions.tsx